import type { TooltipPresentationOptions } from '@bambi/component-library/src/components/forms/FormFieldHelperText/FormFieldHelperText';
import { hoursToSeconds, secondsToHours } from 'date-fns';

import { FormField } from './FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

interface SecondsToHoursFieldProps {
  fieldPath: string;
  disabled?: boolean;
  label: string;
  tooltipHelper?: {
    text: string;
    presentation?: TooltipPresentationOptions;
  };
  inlineHelperText?: string;
}

export default function SecondsToHoursField({
  fieldPath,
  disabled,
  label,
  tooltipHelper,
  inlineHelperText,
}: SecondsToHoursFieldProps) {
  const helper = tooltipHelper && {
    text: tooltipHelper.text,
    presentation: {
      type: 'tooltip' as const,
      ...tooltipHelper.presentation,
    },
  };

  return (
    <FormFieldController name={fieldPath}>
      {({ field, fieldState }) => {
        return (
          <>
            <FormField
              label={label}
              error={fieldState.error?.message?.toString()}
              helperText={helper}
              type="number"
              inputProps={{
                id: fieldPath,
                ...field,
                disabled,
                onChange: (e) => {
                  const value = e.target.value;
                  field.onChange(
                    value === '' ? '' : hoursToSeconds(parseInt(value))
                  );
                },
                value:
                  field.value === '' || field.value == null
                    ? ''
                    : secondsToHours(field.value),
              }}
            />
            {inlineHelperText && (
              <p className="pt-1 text-xs text-gray-500">{inlineHelperText}</p>
            )}
          </>
        );
      }}
    </FormFieldController>
  );
}
